import { Grid, Skeleton, Stack, StackItem } from "@patternfly/react-core";
import type { FC } from "react";
export const SkeletonContainer: FC = () => {
	return (
		<Grid hasGutter span={12}>
			<Stack hasGutter={true}>
				<StackItem>
					<Skeleton fontSize="4xl" />
				</StackItem>
				<StackItem>
					<Skeleton />
					<br />
					<Skeleton />
					<br />
					<Skeleton />
					<br />
					<Skeleton />
					<br />
				</StackItem>
			</Stack>
		</Grid>
	);
};
